<template>
  <div class="menuBox" :style="{'min-width':menuShow?'200px':''}">
    <div class="flex flex-x justify-center text-center"
         style="flex-flow: column;width:100%;height:74px;padding:17px 32px;border-bottom: 1px solid #eff0f1;"
         :style="{'background-color': theme}">
      <div v-if="menuShow" :class="menuShow?'logo':'menuShowLogo'" @click="$router.push('/index')">
        <img src="@/assets/images/login/loginNoText.png" alt="">
        <span>网际通联智能办公系统</span>
        <!--        <span style="color:white;font-size: 30px" >OMS管理系统</span>-->
      </div>
    </div>
    <el-scrollbar wrap-style="overflow-x:hidden;" class="scrollbar" style="height: calc(100% - 74px);">
      <el-menu unique-opened :router="true" :collapse="!menuShow" class="el-menu-vertical border-0"
               :background-color="'#FFFFFF'" text-color="black" mode="vertical" :collapse-transition="false"
               :default-active="activePath">
        <template v-for="item in sidebarRouters">
          <template v-if="!item.hidden">
            <template v-if="item.children && item.children.length>0 && item.meta.menuType===1">
              <el-submenu :index="item.path" :key="item.path">
                <template slot="title">
                  <i v-if="item.meta.icon" :class="item.meta.icon"></i>
                  <span class="font-weight-bold" slot="title">{{ item.meta.title }}</span>
                </template>
                <template v-for="it in item.children">
                  <el-menu-item style="background:#002140" v-if="!it.hidden" :index="resolvePath(item.path,it.path)"
                                :key="it.path">
                    <i v-if="it.meta.icon" :class="it.meta.icon"></i>
                    <span class="font-weight-bold" style="color:#464D5A" slot="title">{{ it.meta.title }}</span>
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
            <template v-else-if="item.children && item.children.length>0 && item.meta.menuType===2">
              <el-menu-item style="background:#002140" v-if="!item.hidden" :index="item.children[0].path"
                            :key="item.children[0].path">
                <i v-if="item.children[0].meta.icon" :class="item.children[0].meta.icon"></i>
                <span class="font-weight-bold" style="color:#464D5A" slot="title">{{
                    item.children[0].meta.title
                  }}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>{{ msg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" class="cancel">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false" class="cofirm">确 定</el-button>
        </span>
      </el-dialog>
    </el-scrollbar>
  </div>
</template>

<script>
import {routeArr} from "@/router";
import {mapGetters} from 'vuex'
import path from "path";

export default {
  name: "NavBar",
  data() {
    return {
      routeArr: routeArr,
      activePath: undefined,
      name: '',
      deptName: '',
      deptLevel: '',
      dialogVisible: false,
      msg: ''
    }
  },
  components: {},
  props: {
    menuShow: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'theme',
      'sideTheme',
      'logoTheme',
      'headerTheme',
      'sidebarRouters'
    ]),
  },
  created() {
    this.routeChange()
  },
  watch: {
    $route() {
      this.routeChange()
    },
  },
  methods: {
    routeChange() {
      const route = this.$route
      if (route) {
        this.activePath = route.fullPath;
      }
    },
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    resolvePath(fPath, cPath) {
      if (this.isExternal(cPath)) {
        return cPath
      }
      if (this.isExternal(fPath)) {
        return this.fPath
      }
      return path.resolve(fPath, cPath)
    }
  }

}
</script>
<style scoped lang="scss">
.menuBox {
  background-color: #ffffff;
  // border-top-left-radius: 8px;
  // border-bottom-left-radius: 8px;
  // padding-top: 20px;
  border-right: 1px solid #eff0f1;

  .logo {
    cursor: pointer;
    // margin-bottom: 10px;
    min-width: 200px;
    position: relative;
    height: 74px;
    line-height: 74px;
    img{
      height: 44px;
      position: absolute;
      left: -10%;
      top: 50% ;
      margin-top: -22px;
      // display: none;
    }
    span{
      font-size: 20px;
      padding-left: 20px;
      box-sizing: border-box;
      font-weight: bold;
      color: #eff0f1;
    }
  }

  .menuShowLogo {
    width: 36px;
    height: 36px;
    
  }

  .scrollbar {
    // background-image: url('../../../assets/images/sys/menuBj.png');
    // background-repeat: no-repeat;
    // background-position: center;
    // background-size: cover;
  }
}

.line {
  width: 150px;
  border-bottom: 1px solid #849DB1;
  margin-top: 24px;
}

.el-menu-vertical:not(.el-menu--collapse) {

}

/deep/ .el-submenu .el-menu-item {
  height: 48px;
  line-height: 48px;
  min-width: 164px;
}

/deep/ .el-menu-item.is-active {
  box-sizing: border-box;
  // background: $mainColor!important;
  background: #f5f6fa !important;
  border-radius: 4px;
  // margin: auto 18px;
  // padding-left: 22px!important;
  box-sizing: border-box;
}

/deep/ .el-submenu__title {
  background: #fff !important;
  color: #464D5A !important;
  transition: border-color .3s, background-color 0s, color .3s;

  i {
    color: #464D5A !important;
  }
}

.el-menu-item, /deep/ .el-submenu__title {
  transition: border-color .3s, background-color 0s, color .3s;
}

/deep/ .el-menu-item {
  background: #fff !important;
  color: #464D5A !important;
}
</style>
